import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home.vue'
import Products from '@/views/Products.vue'
import ProductDetail from '@/views/ProductDetail.vue'
import About from '@/views/About.vue'
import News from '@/views/News.vue'
import Careers from '@/views/Careers.vue'
import { getProduct } from '@/data/catalog'

Vue.use(VueRouter)

// 站点规范域名（用于生成每个页面自身的 canonical）
const SITE_ORIGIN = 'https://www.victoryai.top'
const DEFAULT_DESCRIPTION = '西安韦克德瑞人工智能科技有限公司是专业的工业AI一体化解决方案提供商，以工业大模型为核心，提供智能运维、工艺优化、智能视觉、数字孪生、零碳园区、机器人、传感器及边缘算力等产品与服务，赋能能源电力、煤矿、化工、机械、农业等行业智能化转型。'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '西安韦克德瑞人工智能科技有限公司｜工业AI一体化解决方案提供商',
      description: '西安韦克德瑞人工智能科技有限公司是专业的工业AI一体化解决方案提供商，以工业大模型为核心，提供智能运维、工艺优化、智能视觉、数字孪生、零碳园区、机器人、传感器及边缘算力等产品与服务，赋能能源电力、煤矿、化工、机械、农业等行业智能化转型。'
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
    meta: {
      title: '产品与解决方案 - 西安韦克德瑞',
      description: '西安韦克德瑞产品与解决方案：涵盖工业大模型（PowerMind/IndustMind/OpsMind）、能源电力智能运维、机械工艺优化与质量预测、数字孪生、化工智能管控、零碳园区，以及机器人、传感器、边缘算力等软硬件一体化产品。'
    }
  },
  {
    path: '/products/:slug',
    name: 'ProductDetail',
    component: ProductDetail,
    meta: { title: '产品详情 - 西安韦克德瑞' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '关于我们 - 西安韦克德瑞人工智能科技有限公司',
      description: '西安韦克德瑞人工智能科技有限公司企业介绍：以工业大模型为核心的工业AI一体化解决方案提供商，服务能源电力、煤矿、化工、机械等行业的智能化转型。'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      title: '荣誉与动态 - 西安韦克德瑞',
      description: '西安韦克德瑞荣誉资质与企业动态：了解公司最新新闻、行业活动、媒体报道与获奖信息。'
    }
  },
  {
    path: '/careers',
    name: 'Careers',
    component: Careers,
    meta: {
      title: '加入我们 - 西安韦克德瑞人才招聘',
      description: '加入西安韦克德瑞：查看最新招聘职位与人才发展机会，与我们一起用工业AI推动行业智能化转型。'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

function setMetaContent(name, content) {
  if (!content) return
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

router.beforeEach((to, from, next) => {
  let title = to.meta && to.meta.title
  let description = to.meta && to.meta.description

  // 产品详情页：按 slug 取产品数据，生成唯一 title / description
  if (to.name === 'ProductDetail') {
    const product = getProduct(to.params.slug)
    if (product) {
      title = product.name + ' - 西安韦克德瑞'
      description = product.intro || product.tagline || description
    }
  }

  if (title) {
    document.title = title
  }
  setMetaContent('description', description || DEFAULT_DESCRIPTION)

  // canonical 始终指向当前页面自身的规范 URL（避免所有页面都指向首页）
  const normalizedPath = to.path === '/' ? '/' : to.path.replace(/\/+$/, '')
  setCanonical(SITE_ORIGIN + normalizedPath)

  next()
})

// 百度统计：SPA 路由切换属于"虚拟 PV"，需手动上报，否则只统计首屏
router.afterEach((to) => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }
})

export default router
